import React from "react";
import BarChart from "components/charts/BarChart";
import LineAreaChart from "components/charts/LineAreaChart";
import type { ChartSeries } from "../dashboardData";
import ChartCard from "./ChartCard";
import styles from "./ChartsSection.module.scss";
import { chartColorPalette } from "../dashboardUtils";
import { useI18n } from "context/I18nContext";

type Props = {
  newCardsSeries: ChartSeries[];
  dispenseSeries: ChartSeries[];
  rechargeSeries: ChartSeries[];
  loading?: boolean;
};

function ChartsSection({
  newCardsSeries,
  dispenseSeries,
  rechargeSeries,
  loading = false,
}: Props) {
  const { t } = useI18n();

  return (
    <div className={styles.grid}>
      <ChartCard
        title={t("dashboardPage.charts.newCards.title")}
        subtitle={t("dashboardPage.charts.newCards.subtitle")}
        loading={loading}
        isEmpty={!loading && newCardsSeries.length === 0}
      >
        <LineAreaChart
          data={newCardsSeries}
          lineColor={chartColorPalette.newCards.line}
          areaColor={chartColorPalette.newCards.area}
        />
      </ChartCard>

      <ChartCard
        title={t("dashboardPage.charts.waterDispense.title")}
        subtitle={t("dashboardPage.charts.waterDispense.subtitle")}
        loading={loading}
        isEmpty={!loading && dispenseSeries.length === 0}
      >
        <BarChart
          data={dispenseSeries}
          barColor={chartColorPalette.waterDispense.bar}
        />
      </ChartCard>

      <ChartCard
        title={t("dashboardPage.charts.recharge.title")}
        subtitle={t("dashboardPage.charts.recharge.subtitle")}
        loading={loading}
        isEmpty={!loading && rechargeSeries.length === 0}
      >
        <BarChart
          data={rechargeSeries}
          barColor={chartColorPalette.recharge.bar}
        />
      </ChartCard>
    </div>
  );
}

export default ChartsSection;
